import type { TranslationObj } from "$/utils/lang"

import {
    ESessionModality,
    type ICoachPaginatedSessionDto,
    type ICoachPaginatedSessionModel,
    type IPaginatedQueryDto,
    type IPaginatedQueryModel,
    type ISessionBaseDto,
    type ISessionBaseModel,
    type TSessionModality
} from "@/3514/types"

type TCoachDashboardQueryOrder = "start" | "-start"

type TCoachDashboardQueryPeriod = "upcoming_sessions" | "past_sessions"

type TCoachDashboardSessionsQueryKeyPayload = {
    search: string
    page: number
    period: TCoachDashboardQueryPeriod
    order: TCoachDashboardQueryOrder
}

type TCoachDashboardParticipantsQueryKeyPayload = {
    search: string
    page: number
}

// dtos --start
interface ICoachSessionWithoutAttendanceMarksDto {
    session_id: number | null
    session_time: string | null
    session_type: string | null
    title: string | null
    photo: string | null
    session_modality: TSessionModality
    duration: number
    is_extra_party: boolean
}

type TCoachDashboardParticipantsQueryModuleStatusDto = "queued" | "late" | "on_track"

interface ICoachDashboardParticipantsQueryModuleDto {
    status: TCoachDashboardParticipantsQueryModuleStatusDto
    version_id: number
    version_name: TranslationObj
}

interface ICoachDashboardParticipantsQueryCohortDto {
    id: number
    name: string
    slug: string
}

interface ICoachDashboardParticipantsQueryParticipantDto {
    cohorts: ICoachDashboardParticipantsQueryCohortDto | {}
    current_module: ICoachDashboardParticipantsQueryModuleDto | {}
    first_name: string
    id: number
    last_name: string
    photo: string | null
    upcoming_sessions: ISessionBaseDto[] | []
}

interface ICoachDashboardParticipantsQueryDto
    extends IPaginatedQueryDto<ICoachDashboardParticipantsQueryParticipantDto> {}

interface ICoachDashboardSessionsQueryCohortFilterDto {
    id: number | null
    name: string
}

interface ICoachDashboardSessionsQueryDto extends IPaginatedQueryDto<ICoachPaginatedSessionDto> {
    filters: { cohorts: ICoachDashboardSessionsQueryCohortFilterDto[]; sessions: TCoachDashboardQueryPeriod[] }
}
// dtos --end

// models --start
interface ICoachSessionWithoutAttendanceMarksModel {
    sessionId: number
    sessionTime: string
    sessionType: string | null
    title: string
    photo: string | null
    sessionModality: ESessionModality
    duration: number
    isExtraParty: boolean
}

enum ECoachDashboardParticipantsQueryModuleStatus {
    Queued = "queued"
}

interface ICoachDashboardParticipantsQueryParticipantModel {
    cohortId: number | null
    cohortName: string | null
    cohortSlug: string | null
    moduleStatus: ECoachDashboardParticipantsQueryModuleStatus | null
    moduleVersionId: number | null
    moduleVersionName: TranslationObj | null
    firstName: string
    id: number
    lastName: string
    photo: string | null
    upcomingSessions: [] | ISessionBaseModel[]
}

interface ICoachDashboardParticipantsQueryModel
    extends IPaginatedQueryModel<ICoachDashboardParticipantsQueryParticipantModel> {}

interface ICoachDashboardSessionsQueryCohortFilterModel {
    id: number | null
    name: string
}

interface ICoachDashboardSessionsQueryModel extends IPaginatedQueryModel<ICoachPaginatedSessionModel> {
    filters: { cohorts: ICoachDashboardSessionsQueryCohortFilterModel[]; sessions: TCoachDashboardQueryPeriod[] }
}

// models --end

export { ECoachDashboardParticipantsQueryModuleStatus }
export type {
    TCoachDashboardQueryOrder,
    TCoachDashboardQueryPeriod,
    TCoachDashboardSessionsQueryKeyPayload,
    TCoachDashboardParticipantsQueryKeyPayload,
    // dtos
    ICoachSessionWithoutAttendanceMarksDto,
    TCoachDashboardParticipantsQueryModuleStatusDto,
    ICoachDashboardParticipantsQueryModuleDto,
    ICoachDashboardParticipantsQueryCohortDto,
    ICoachDashboardParticipantsQueryParticipantDto,
    ICoachDashboardParticipantsQueryDto,
    ICoachDashboardSessionsQueryCohortFilterDto,
    ICoachDashboardSessionsQueryDto,
    // models
    ICoachSessionWithoutAttendanceMarksModel,
    ICoachDashboardParticipantsQueryParticipantModel,
    ICoachDashboardParticipantsQueryModel,
    ICoachDashboardSessionsQueryCohortFilterModel,
    ICoachDashboardSessionsQueryModel
}
